import { render, staticRenderFns } from "./ProductReservation.vue?vue&type=template&id=958d27e0&"
import script from "./ProductReservation.vue?vue&type=script&lang=js&"
export * from "./ProductReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports